import { ReactNode } from 'react';

const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Orden i en sökning som API:t söker på: minst två tecken, utan dubbletter. */
export const getSearchWords = (query: string): string[] =>
  query
    .split(/\s+/)
    .filter((word) => word.length >= 2)
    .filter((word, i, all) => all.findIndex((x) => x.toLocaleLowerCase('sv') === word.toLocaleLowerCase('sv')) === i);

/**
 * Texten med sökorden i fetstil, skiftlägesokänsligt. Längsta ordet först i mönstret, så att "förening" blir fet hela
 * vägen även när "för" också söks. Byggs som React-element, så att texten aldrig tolkas som HTML.
 */
export const highlightWords = (text: string, query: string): ReactNode[] => {
  const words = getSearchWords(query).sort((a, b) => b.length - a.length);
  if (words.length === 0) return [text];

  const pattern = new RegExp(`(${words.map(escapeRegExp).join('|')})`, 'gi');

  return text.split(pattern).map((part, i) =>
    // Delarna kommer i fast ordning ur samma text, så index är en stabil nyckel här.
    // eslint-disable-next-line react/no-array-index-key
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part,
  );
};
